import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import './contestpopup.css'

const ContestPopup = ({closeHandler}) => {
    return (
        <div className="popup-container">
            <div className="popup-box">
                <FontAwesomeIcon onClick={closeHandler} className='custom-close' icon={faTimes} /> 
                <h4>You're in! Good luck! Download Elite Partyz to make planning your next party as simple as getting your kids to eat cake!</h4>
                <div className="button-grp">
                    <Link to='/members'>
                            Download now
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ContestPopup